// Pomocník pro hotlinkované fotografie z volných bank (Unsplash CDN).
// Konkrétní URL byly ověřeny (HTTP 200). Parametry: auto=format (WebP/AVIF),
// fit=crop, w, q=72 — drží hmotnost pod rozumnou mezí.

export function unsplash(id: string, width: number): string {
  return `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${width}&q=72`;
}

export function unsplashSrcSet(
  id: string,
  widths: readonly number[],
): string {
  return widths.map((w) => `${unsplash(id, w)} ${w}w`).join(", ");
}

export const IMAGE_WIDTHS = {
  wide: [640, 1024, 1600] as const,
  tile: [400, 800, 1200] as const,
};
